class ConfirmationModal extends HTMLElement {
  constructor() {
    super();


    const shadow = this.attachShadow({ mode: 'open' });


    shadow.innerHTML = `
      <style>
        .modal {
            font-family: Inter;

          display: none;
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }
        .modal.active {
          display: flex;
        }
        .modal-content {
        margin: 2rem;
          background: white;
          padding: 20px;
           border-radius: 0;
          text-align: center;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }
        .modal-actions {
          margin-top: 10px;
          display: flex;
          justify-content: center;
          gap: 10px;
        }
       button {
           font-family: Inter;

    padding: 10px 20px;
    cursor: pointer;
    border-radius: 0;
    border: 1px solid black;
    font-size: 14px;
    font-weight: bold;
}
        .confirm {
    background-color: transparent;
    color: black;
}
       
        .cancel {
    background-color: black;
    color: white;
}
     
      </style>
      <div class="modal">
        <div class="modal-content">
          <p>Are you sure you want to remove this item from the cart?</p>
          <div class="modal-actions">
            <button class="confirm">YES</button>
            <button class="cancel">NO</button>
          </div>
        </div>
      </div>
    `;
  }

  show(callback) {
    const modal = this.shadowRoot.querySelector('.modal');
    const confirmButton = modal.querySelector('.confirm');
    const cancelButton = modal.querySelector('.cancel');

    modal.classList.add('active');

    const closeModal = () => {
      modal.classList.remove('active');
      confirmButton.removeEventListener('click', onConfirm);
      cancelButton.removeEventListener('click', onCancel);
    };

    const onConfirm = () => {
      closeModal();
      if (callback) callback(true);
    };

    const onCancel = () => {
      closeModal();
      if (callback) callback(false); 
    };

    confirmButton.addEventListener('click', onConfirm);
    cancelButton.addEventListener('click', onCancel);
  }
}

customElements.define('confirmation-modal', ConfirmationModal);
